import * as React from 'react';
import { V2FeaturedHotelDealsMap } from './v2-featured-hotel-deals-map';

// Css Style Import
import(/* webpackChunkName: "v2-V2FeaturedHotelDeals-styles" */ '../styles/v2-featured-hotel-deals.css');

/**
 * Looks at the code-split V2FeaturedHotelDealsComponent map and renders the desired ui component based on the name.
 */
export const V2FeaturedHotelDealsComponent = (props: any) => {
  const component = V2FeaturedHotelDealsMap;

  if (!component) {
    return null;
  }

  return React.createElement(component as any, props);
};